<div class="switch">
  <label>
    <input type="checkbox" [(ngModel)]="checked" (change)="checkedChange.emit(checked)" [disabled]="disabled" />
    <span class="slider"></span>
  </label>
  <div class="pl-3">
    @if (label) {
      {{ label }}
    } @else {
      <ng-content />
    }
  </div>
</div>
